var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deals-page"},[_c('app-header',{attrs:{"loggedIn":true}}),(_vm.isAccess)?_c('deals-list',{attrs:{"extended":true}}):_vm._e(),(!_vm.isAccess)?_c('login-required'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }